import { render, staticRenderFns } from "./ForgottenPasswordComponent.vue?vue&type=template&id=ffe45584&scoped=true&"
import script from "./ForgottenPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPasswordComponent.vue?vue&type=style&index=0&id=ffe45584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe45584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffe45584')) {
      api.createRecord('ffe45584', component.options)
    } else {
      api.reload('ffe45584', component.options)
    }
    module.hot.accept("./ForgottenPasswordComponent.vue?vue&type=template&id=ffe45584&scoped=true&", function () {
      api.rerender('ffe45584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/ForgottenPasswordComponent.vue"
export default component.exports